import { authClient } from "./client";
import { wasSuspended } from "./suspension";

// Kept in memory, as the suspension is: signing out clears the tab's storage before the sign-in page reads it.
let byChoice = false;
let expired = false;

/** Signs the person out at their own asking: the sign-in page that follows says nothing of an expiry. */
export async function signOutByChoice(): Promise<void> {
  byChoice = true;
  await (await authClient()).signOut({ scope: "local" });
}

/** Notes the end of the tab's session. One the person did not ask for, a refresh refused or a request answered 401,
 * is an expiry, which the sign-in page says and comes back from to the page the person was on; a suspension says its
 * own word. */
export function sessionEnded(): void {
  expired = !byChoice && !wasSuspended();
  byChoice = false;
}

/** Whether the last end of the session was an expiry. */
export function wasExpired(): boolean {
  return expired;
}

export function forgetExpiry(): void {
  expired = false;
}

/** The page to come back to after signing in, from the address of the sign-in page: one of the app's own, never another
 * site's. */
export function returnPathOf(search: unknown): string | undefined {
  if (typeof search !== "object" || search === null || !("redirect" in search)) {
    return undefined;
  }
  const path = search.redirect;
  return typeof path === "string" && isOwnPath(path) ? path : undefined;
}

/** A path of this origin: one slash, and no second one or backslash after it that a browser reads as another host. */
function isOwnPath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//") && !path.startsWith("/\\");
}
